module.exports = __webpack_public_path__ + "static/media/license_01.b6b923ce.svg";